import { type SystemTaskKey, taskAssigneeProfiles } from "@recobra/schemas/task-catalog";

export type AssignmentCandidate = {
  groups: readonly string[];
  clientIds: readonly string[];
  branchIds: readonly string[];
};
export type CaseScope = { clientId: string; branchId?: string | null };

export const canAssignTask = (
  system: SystemTaskKey | null,
  groups: readonly string[],
  allowedGroups: readonly string[],
  customerInScope = false,
): boolean =>
  groups.includes("Admin") ||
  taskAssigneeProfiles(system).some(
    (group) =>
      groups.includes(group) &&
      (!allowedGroups.length || allowedGroups.includes(group)) &&
      (group !== "Customer" || customerInScope),
  );

export const canConfigureTaskAssignee = (
  system: SystemTaskKey | null,
  groups: readonly string[],
  allowedGroups: readonly string[],
): boolean =>
  (system !== "provide_case_documents" || !groups.includes("Customer")) &&
  canAssignTask(system, groups, allowedGroups);

export const isInCaseScope = (candidate: AssignmentCandidate, context: CaseScope): boolean =>
  candidate.clientIds.includes(context.clientId) ||
  (context.branchId != null && candidate.branchIds.includes(context.branchId));
